import React from "react";
import { Helmet } from "react-helmet";

// One owner for page identity, used both by the build and browser navigation.
export default function PageMetadata({ title, description, seo, type = "website", children }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={seo.canonical} />
      <link rel="alternate" hrefLang="it" href={seo.alternates.it} />
      <link rel="alternate" hrefLang="en" href={seo.alternates.en} />
      <link rel="alternate" hrefLang="x-default" href={seo.alternates.default} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:locale" content={seo.ogLocale} />
      <meta property="og:locale:alternate" content={seo.ogLocaleAlternate} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {children}
    </Helmet>
  );
}
